import React, { useState, useEffect, useRef } from 'react'
import { Input, Button } from 'antd'
import { Clock } from 'lucide-react'
import type { LineItem } from '../../types/ffe'

interface Props {
  item: LineItem
  onUpdate: (updates: Partial<LineItem>) => void
}

export const LineItemLeadTime: React.FC<Props> = ({ item, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [tempValue, setTempValue] = useState(item.leadTime || '')
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isEditing])

  useEffect(() => {
    setTempValue(item.leadTime || '')
  }, [item.leadTime])

  const handleSubmit = () => {
    onUpdate({ leadTime: tempValue })
    setIsEditing(false)
  }

  if (isEditing) {
    return (
      <Input
        ref={inputRef}
        value={tempValue}
        onChange={(e) => setTempValue(e.target.value)}
        onBlur={handleSubmit}
        placeholder="Enter lead time"
        className="w-[150px]"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSubmit()
          } else if (e.key === 'Escape') {
            setTempValue(item.leadTime || '')
            setIsEditing(false)
          }
        }}
      />
    )
  }

  return (
    <Button
      type="text"
      icon={<Clock className="h-4 w-4 text-gray-400" />}
      className="h-auto py-1 px-2 hover:bg-gray-50"
      onClick={() => setIsEditing(true)}
    >
      <span className="text-gray-600">
        {item.leadTime || <span className="text-gray-400">Add lead time</span>}
      </span>
    </Button>
  )
}
